<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if='!$route.meta.keepAlive'></router-view>
  </div>
</template>

<script>
export default {
  name: "sqgg-index",
  data() {
    return {
      //arr : ['activitylist','fangyilist','walkRecord',healthRecord,eventQuery,eventHandle,landTransfer,taxInfo,maintenance,companyInfo,priceDifference,regfee,questionList,workQuestionList]
    }
    
  },
  methods: {
    initSideBar() {
      this.$store.commit("updateSideList", this.sidebar);
    }
  },
  computed: {
    sidebar() {
      return JSON.parse(this.$store.state.shequSideBar);
    }
  },
  mounted() {
    this.initSideBar();
  }
};
</script>

<style scoped></style>
